import { render, staticRenderFns } from "./HelpdeskEmails.vue?vue&type=template&id=0d6f0202"
import script from "./HelpdeskEmails.vue?vue&type=script&lang=js"
export * from "./HelpdeskEmails.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskEmails.vue?vue&type=style&index=0&id=0d6f0202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports